import type { ExpenseView } from '@chukua/common';
import { Tag } from 'antd';
import { EXPENSE_STATE_LABELS, EXPENSE_STATE_TAG_COLOURS } from '../policies/expense-labels';

/** An expense's state as the Expenses screen shows it, for the trip page's list. */
export function ExpenseStateTag({ state }: { state: ExpenseView['state'] }) {
  return <Tag color={EXPENSE_STATE_TAG_COLOURS[state]}>{EXPENSE_STATE_LABELS[state]}</Tag>;
}
